import './rater.subjectivity.modal.body.scss';

import {
  CreateSubjectivityField,
  getCreateSubjectivityFieldProps,
} from '@converge/data';
import { UseFormReturn, useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';
import { CreateCustomSubjectivityField } from './rater.subjectivities.list';
import { NewFormTextField } from '../../../../presentation/components';
import { useEffect } from 'react';

export interface RaterSubjectivityModalBodyProps {
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  subjectivityUuid: string;
  subjectivityName: string;
  formMethods: UseFormReturn<CreateCustomSubjectivityField, unknown>;
}

export const RaterSubjectivityModalBody = ({
  setIsDisabled,
  subjectivityUuid,
  subjectivityName,
  formMethods,
}: RaterSubjectivityModalBodyProps) => {
  const { watch } = useFormContext();

  const customSubjectivity = watch(
    CreateSubjectivityField.customSubjectivityNameField
  )?.trim();

  useEffect(() => {
    setIsDisabled(!customSubjectivity);
  }, [customSubjectivity, setIsDisabled]);

  useEffect(() => {
    formMethods.setValue(
      CreateSubjectivityField.customSubjectivityNameField,
      subjectivityName
    );
  }, [subjectivityName, formMethods]);
  return (
    <>
      <Box className="context-midterm-transaction">
        Include as much detail as necessary for this custom subjectivity.
      </Box>

      <Box>
        <NewFormTextField
          {...getCreateSubjectivityFieldProps(
            CreateSubjectivityField.customSubjectivityNameField
          )}
          autoComplete={false}
          placeholder="Enter custom subjectivity"
          data-testid="custom-subjectivity"
          multiline
          rows={6}
        />
      </Box>
    </>
  );
};
